import React, { useState, useEffect } from 'react';
import Breadcrumb from "components/shared/Breadcrumb";
import Select from 'react-select';
import MaterialTable from 'material-table';
import { toast } from "react-toastify";
import vmwareService from "services/admin/masters/vmwareService";
import ConfirmBox from "components/shared/VmwareMappingConfirmBox";
import {MSG_CREATE_RECORD,
  MSG_DELETE_RECORD,
  MSG_MAPPING_DELETE_WARNING
  } from "constants/admin/masters/vmware";
  import {
    ERROR_MESSAGE_UNKNOWN
  } from "constants/common";
import {getMatrixId} from "utils/matriceHelpers";
function ManageVmwareCombineKey({ props }) {
  const [breadcrumbs, setBreadCrumbs] 
    = useState([
      { title: "UCP VMware Masters Mapping", url: "/admin/master/ucp-vmware/" },
      { title: "Manage Mapping" },
    ]);
  const serviceObj = new vmwareService();

  const [combineKeyDetails, getCombinekeyDetails] = useState([]);
  const [ucpPlatformList, setUcpPlatformList] = useState(null);
  const [serverModelList, setServerModelList] = useState(null);
  const [ucpReleaseVersionList, setUcpReleaseVersionList] = useState(null);
  const [selectedUcpPlatform, setUcpPlatform] = useState(null);
  const [selectedServerModel, setServerModel] = useState(null);
  const [selectedUcpReleaseVersion, setUcpReleaseVersion] = useState(null);
  const [combineKey, setCombineKey] = useState("");
  const [combineKeyError, setCombineKeyError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [showDeleteConfirmBox, setDeleteConfirmBoxFunction] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [itemToBeDeleted, setItemToBeDeleted] = useState(null);
  const [copiedCombineKey, setCopiedCombineKey] = useState(0);

  const Id = getMatrixId(window.location.pathname);
 
  useEffect(() => {
    getData();
  }, [])

  const getData = () => {
    serviceObj.getAllInitialData(Id)
      .then((response) => {
        getCombinekeyDetails(response?.vmware_combine_keys_list);
        // structuring ucpPlatforms items for dropdown list
        let ucpPlatforms = response?.ucp_platform_dropdown_list.map((item) => {
          return { id: item.id, value: item.name, label: item.name, disabled: item.disabled }
        })
        setUcpPlatformList(ucpPlatforms);

        // structuring server model items for dropdown list
        let serverModelList = response?.server_model_dropdown_list.map((item) => {
          return { id: item.id, value: item.name, label: item.name, disabled: item.disabled }
        })
        setServerModelList(serverModelList);
        // structuring server model items for dropdown list
        let UcpReleaseVersionList = response?.ucp_release_version_dropdown_list.map((item) => {
          return { id: item.id, value: item.name, label: item.name, disabled: item.disabled }
        })

        setUcpReleaseVersionList(UcpReleaseVersionList)
      })
      .catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
      })
  }
  const submitForm = async (e) => {
    e.preventDefault();
  }
  const resetForm = () => {
    setUcpPlatform(null);
    setServerModel(null);
    setUcpReleaseVersion(null);
    setCombineKey("");
    setCombineKeyError(false);
    setErrorMsg("");
    setCopiedCombineKey(null);
  }
 
  const getCombineKeyValue = () => {

    if (selectedUcpPlatform && selectedServerModel && selectedUcpReleaseVersion) {
      setCombineKey(selectedUcpPlatform?.value + "-" + selectedServerModel?.value + "-" + selectedUcpReleaseVersion?.value)
  
    } else if (!selectedUcpPlatform || !selectedServerModel || !selectedUcpReleaseVersion) {
      // toast("Please select values from all dropdown to generate combine key!")
      setCombineKeyError(true);
      setErrorMsg("Please select values from all above dropdowns to generate combine key!")
    }
  }
  const changeCombineKey = (e) => {
    setCombineKey(e.target.value);
  }

  const setUcpPlatformfunction = (e) => {
    setUcpPlatform(e);
    setCombineKey("")
  }

  const setServerModelFunction = (e) => {
    setServerModel(e);
    setCombineKey("")
  }
  const setUcpReleaseVersionFunction = (e) => {
    setUcpReleaseVersion(e);
    setCombineKey("");
  }
  const addCombineKey = () => {
    // check validation
    if (combineKey !== "") {
      // call api

      let apiData = {
        combine_key: combineKey,
        ucp_platform: selectedUcpPlatform.value,
        server_model_id: selectedServerModel.id,
        ucp_release_version_id: selectedUcpReleaseVersion.id,
        copy_from_id: copiedCombineKey? copiedCombineKey.id: 0
      }
      serviceObj.createCombinekey(apiData).then((response) => {
        toast.success(MSG_CREATE_RECORD);
        getData();
        resetForm();
      })


    }
    else {
      setCombineKeyError(true);
      setErrorMsg("Please select values from all above dropdowns to generate combine key!")
    }

  }
  const deleteCombinekey = () => {

    serviceObj.deleteVmwareCombineKey(itemToBeDeleted.id)
      .then((response) => {
        toast.success(MSG_DELETE_RECORD);
        setDeleteConfirmBoxFunction(false)
        setConfirmMessage("");
        getData();
        setItemToBeDeleted(null);
      })
      .catch((error) => {
        setDeleteConfirmBoxFunction(false)
        setConfirmMessage("");
        setItemToBeDeleted(null);
      })
  }
  const showDeleteWarning = (rowData) => {
    setDeleteConfirmBoxFunction(true);
    setItemToBeDeleted(rowData);
    setConfirmMessage( MSG_MAPPING_DELETE_WARNING + rowData.combine_key + "?")
  }
  const cancelDeleteItem = () => {
    setDeleteConfirmBoxFunction(false);
    setItemToBeDeleted(null);
  }
  return (
    <div className="form-wrap mt-3">
      <Breadcrumb data={breadcrumbs} disableEditTitle={true} />
      {showDeleteConfirmBox ? (
        <ConfirmBox
          actionHandler={deleteCombinekey}
          handleSubmit={deleteCombinekey}
          cancelDeleteItem={cancelDeleteItem}
        >
          {confirmMessage}
        </ConfirmBox>
      ) : null}
      <div className="form-group d-flex">
        <div className="col-sm-6">
          <form onSubmit={submitForm} >
            <div className="row pl-2 pb-1">
              <div className="col-sm-11 pb-2">
                <h5><label className="mr-sm-2"><b>Create Combine Key</b></label></h5>
                <label htmlFor="" className="mr-sm-2">UCP Platform</label>
                <Select
                  className={`basic-single mb-1`}
                  classNamePrefix="select"
                  // isDisabled={isEditForm}
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  isClearable={true}
                  isSearchable={true}
                  //  filterOption={customFilter}
                  name={"UCP Platform Dropdown List"}
                  options={ucpPlatformList}
                  value={selectedUcpPlatform}
                  onChange={(e) => setUcpPlatformfunction(e)}

                />
              </div>
            </div>
            <div className="row pl-2 pb-1">
              <div className="col-sm-11 pb-2">
                <label htmlFor="" className="mr-sm-2">Server Model</label>

                <Select
                  isDisabled={false}
                  className={`basic-single mb-1`}
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  //  filterOption={customFilter}
                  name={"Server Model"}
                  options={serverModelList}
                  value={selectedServerModel}
                  onChange={(e) => setServerModelFunction(e)}

                />
              </div>
            </div>
            <div className="row pl-2 pb-1">
              <div className="col-sm-11 pb-2">
                <label htmlFor="" className="mr-sm-2">UCP Release Version</label>

                <Select
                  isDisabled={false}
                  className={`basic-single mb-1`}
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  //  filterOption={customFilter}
                  name={"UCP Release Version"}
                  options={ucpReleaseVersionList}
                  value={selectedUcpReleaseVersion}
                  onChange={(e) => setUcpReleaseVersionFunction(e)}

                />
              </div>
            </div>


            {/* Combine key text field */}
            <div className="row pl-2 pb-1">
              <div className='col-sm-4 mb-2'>
                <button
                  type="submit"
                  className="btn btn-md btn-dark mb-3"
                  onClick={getCombineKeyValue}>
                  Generate Combine Key
                </button>
              </div>
              {combineKeyError && <div className='col-sm-8 mb-2'>


                <div class="text-danger">{errorMsg}</div>

              </div>
              }

            </div>
            <div className="row pl-2 pb-1">
              <div className="col-sm-11 pb-2">

                <input type="text"
                  className="form-control"
                  maxLength="60"
                  name="Combine Key Value"
                  value={combineKey}
                  onChange={(e) => changeCombineKey(e)}
                  placeholder="Combine Key"
                />
              </div>
            </div>

            <div className="row pl-2 pb-1">
           
              <div className="col-sm-11 pb-2">
              <label htmlFor={"Copy From Existing Combine Key"} className="mr-sm-2"><b>Copy From Existing Combine Keys</b></label>
              <Select
                  isDisabled={combineKey !== ""? false:true}
                  className={`basic-single mb-1`}
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  name={"Combine Keys"}
                  options={combineKeyDetails.map(item=>({ id: item.id, value: item.combine_key, label: item.combine_key }))}
                  value={copiedCombineKey}
                  onChange={(e) => setCopiedCombineKey(e)}

                />
              </div>
            </div>
            <div className="col-sm-12">
              <button type="reset"
                onClick={resetForm}
                className="btn btn-md btn-light btn-link submit-btn-inline mr-sm-2"><i className="fa fa-refresh"></i> Reset</button>
              <button
                type="submit"
                className="btn btn-md btn-dark submit-btn-inline"
                // disabled={isSubmitting}
                onClick={addCombineKey}
              >
                Add Combine Key
                {/* {isSubmitting?"Please wait...": isEditableForm?"Update":"Add"}  */}
              </button>
            </div>
          </form>
        </div>
        {/* Combine key details table */}
        <div className="col-sm-6">
          {/* <label htmlFor={"VMware CPLD Mapping"} className="mr-sm-2"><b>List of Combine Key</b></label>*/}
          <MaterialTable
            title="Combine Keys"
            columns={[
              { title: 'Combine Key', field: 'combine_key' },
              { title: "UCP Platform", field: 'ucp_platform' },
              { title: "Server Model", field: 'server_model' },
              { title: "UCP Release Version", field: 'ucp_release_version' },
            ]}

            data={combineKeyDetails}

            options={{
              headerStyle: {
                backgroundColor: '#e9ecef',
              },
              actionsColumnIndex: -1,
              selection: false,
              search: true,
              maxBodyHeight: 400

            }}

            localization={{
              header: {
                actions: 'Actions',
              },
            }}
            actions={[
              (rowData)=>({
                icon: rowData.is_deleted? "undo" : "delete",
                tooltip: rowData.is_deleted ? "Undo Deleted Record":"Delete Record",
                onClick:  (e, data)=>{
                 if(rowData.is_deleted){
                  // call undo delete api
                  alert("TRIGGER UNDO DELETE API CALL")
                 }
                 showDeleteWarning(data)
                }
                
              })    
            ]}
          />
        </div>
      </div>
    </div>
  )
}

export default ManageVmwareCombineKey
